import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AltriSoggettiFormComponent } from './dialogs/form/form.component';
import { AltriSoggettiComponent } from './altri-soggetti.component';

const routes: Routes = [
  {
    path: '', component: AltriSoggettiComponent
  },
  {
    path: 'inserisci', component: AltriSoggettiFormComponent,
    data: { title: 'Inserimento Altri Soggetti' },
  },
  { path: ':idAltroSoggetto', loadChildren: () => import('./view/altro-soggetto-view.module').then(m => m.AltroSoggettoViewModule) },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AltriSoggettiRoutingModule { }
